import { useState, useEffect } from 'react'
import { LeftArw } from '../../assests/ExportImageIcon'
import { useNavigate, useLocation } from 'react-router-dom'
import service from '../../services/service'
import endpoints from '../../services/endpoints'

const AddUser = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const userId = state?.userId;
    const isEdit = userId !== null && userId !== undefined;
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [error, setError] = useState("");
    const [form, setForm] = useState({
        name: "",
        customerName: "",
        email: "",
        phoneNumber: "",
        communicationPreference: "",
        propertyType: "",
        monthlyBudget: "",
        bedroomCount: "",
        bathroomCount: "",
        leaseStartDate: "",
        idealHomeDescription: "",
        neighborhoodPreferences: "",
        areaPreference: "",
        specificNeighborhoods: "",
        commuteTime: "",
        mustHaveFeatures: "",
        dealBreakers: "",
        identifiedProperties: "",
        familyNeeds: "",
        petType: "",
        petDetails: "",
        hobbiesInterests: "",
        settlingPriorities: "",
        topPriorities: "",
        documentationAssistance: "",
        communityIntroductions: "",
        settledQuicklySupport: "",
        additionalNotes: "",
    });

    useEffect(() => {
        if (!isEdit) return;
        const fetchUser = async () => {
            try {
                const url = endpoints.admin.userDetail.replace("{user_id}", userId);
                const res = await service.get(url);
                const d = res.data?.data || {};
                setForm({
                    // name: d.name || "",
                    customerName: d.customerName || "",
                    email: d.email || "",
                    phoneNumber: d.phoneNumber || "",
                    communicationPreference: d.communicationPreference || "",
                    propertyType: d.propertyType || "",
                    monthlyBudget: d.monthlyBudget || "",
                    bedroomCount: d.bedroomCount || "",
                    bathroomCount: d.bathroomCount || "",
                    leaseStartDate: d.leaseStartDate || "",
                    idealHomeDescription: d.idealHomeDescription || "",
                    neighborhoodPreferences: d.neighborhoodPreferences || "",
                    areaPreference: d.areaPreference || "",
                    specificNeighborhoods: d.specificNeighborhoods || "",
                    commuteTime: d.commuteTime || "",
                    mustHaveFeatures: d.mustHaveFeatures || "",
                    dealBreakers: d.dealBreakers || "",
                    identifiedProperties: d.identifiedProperties || "",
                    familyNeeds: d.familyNeeds || "",
                    petType: d.petType || "",
                    petDetails: d.petDetails || "",
                    hobbiesInterests: d.hobbiesInterests || "",
                    settlingPriorities: d.settlingPriorities || "",
                    topPriorities: d.topPriorities || "",
                    documentationAssistance: d.documentationAssistance || "",
                    communityIntroductions: d.communityIntroductions || "",
                    settledQuicklySupport: d.settledQuicklySupport || "",
                    additionalNotes: d.additionalNotes || "",
                });
            } catch (err) {
                console.error("Failed to fetch user:", err);
            }
        };
        fetchUser();
    }, [userId, isEdit]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (isEdit) {
                const url = endpoints.admin.updateUser.replace("{user_id}", userId);
                await service.put(url, form);
                navigate("/dashboard/user-detail", { state: { userId } });
            } else {
                const res = await service.post(endpoints.admin.createUser, form);
                const newUserId = res.data?.data?.id || res.data?.data?.user_id;
                if (newUserId) {
                    const sendlinkUrl = endpoints.admin.sendlink.replace("{user_id}", newUserId);
                    await service.post(sendlinkUrl, {});
                }
                setShowSuccess(true);
                setTimeout(() => navigate("/dashboard"), 2500);
            }
        } catch (err) {
            console.error("Failed to save user:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        {showSuccess && (
            <div className="confirm-overlay">
                <div className="confirm-modal">
                    <div className="success-icon">✓</div>
                    <h3>User Added Successfully!</h3>
                    <p>Mail has been sent to <strong>{form.email}</strong></p>
                </div>
            </div>
        )}
        <div>
            <div className='commonBorder commonRadius-12 bg-white'>
                <div className="topPart">
                    <div className="d-flex gap-3 align-items-center">
                        <div className="btnAction" onClick={() => navigate("/dashboard")}><img src={LeftArw} /></div>
                        <div className="heading">{isEdit ? "Edit User" : "Add User"}</div>
                    </div>
                    <div className="rightSide">
                        <button type="button" className="commonOrngBtn" onClick={handleSubmit} disabled={loading}>
                            {loading ? "Saving..." : isEdit ? "Update" : "Send Email"}
                        </button>
                    </div>
                </div>
            </div>

            <div className='formArea mt-3 commonBorder commonRadius-12 bg-white'>
                <form onSubmit={handleSubmit}>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='formhead'>Basic Details</div>
                        </div>
                        {/* <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Name <span className='text-danger'>*</span></label>
                                <input type='text' name='name' placeholder='Enter' value={form.name} onChange={handleChange} required />
                            </div>
                        </div> */}
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Customer Name <span className='text-danger'>*</span></label>
                                <input type='text' name='customerName' placeholder='Enter' value={form.customerName} onChange={handleChange} required />
                            </div>
                        </div>
                         <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Email ID <span className='text-danger'>*</span></label>
                                <input type='email' name='email' placeholder='Enter' value={form.email} onChange={handleChange} required />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Phone Number</label>
                                <input type='text' name='phoneNumber' placeholder='Enter' value={form.phoneNumber} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Communication Preference</label>
                                <input type='text' name='communicationPreference' placeholder='Enter' value={form.communicationPreference} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='col-md-12 mt-5'>
                            <div className='formhead'>Property & Budget Requirements</div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Property Type</label>
                                <input type='text' name='propertyType' placeholder='Enter' value={form.propertyType} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Monthly Budget</label>
                                <input type='text' name='monthlyBudget' placeholder='Enter' value={form.monthlyBudget} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Bedroom Count</label>
                                <input type='text' name='bedroomCount' placeholder='Enter' value={form.bedroomCount} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Bathroom Count</label>
                                <input type='text' name='bathroomCount' placeholder='Enter' value={form.bathroomCount} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Lease Start Date</label>
                                <input type='text' name='leaseStartDate' placeholder='Enter' value={form.leaseStartDate} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='form-group'>
                                <label>Ideal Home Description</label>
                                <textarea rows={4} name='idealHomeDescription' placeholder='Enter' value={form.idealHomeDescription} onChange={handleChange}></textarea>
                            </div>
                        </div>
                        <div className='col-md-12 mt-5'>
                            <div className='formhead'>Location Preferences</div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Neighborhood Preferences</label>
                                <input type='text' name='neighborhoodPreferences' placeholder='Enter' value={form.neighborhoodPreferences} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Area Preference</label>
                                <input type='text' name='areaPreference' placeholder='Enter' value={form.areaPreference} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Specific Neighborhoods</label>
                                <input type='text' name='specificNeighborhoods' placeholder='Enter' value={form.specificNeighborhoods} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Commute Time</label>
                                <input type='text' name='commuteTime' placeholder='Enter' value={form.commuteTime} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-12 mt-5'>
                            <div className='formhead'>Lifestyle & Specific Needs</div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Must Have Features</label>
                                <input type='text' name='mustHaveFeatures' placeholder='Enter' value={form.mustHaveFeatures} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Deal Breakers</label>
                                <input type='text' name='dealBreakers' placeholder='Enter' value={form.dealBreakers} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Identified Properties</label>
                                <input type='text' name='identifiedProperties' placeholder='Enter' value={form.identifiedProperties} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Family Needs</label>
                                <input type='text' name='familyNeeds' placeholder='Enter' value={form.familyNeeds} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Pet Type</label>
                                <input type='text' name='petType' placeholder='Enter' value={form.petType} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Pet Details</label>
                                <input type='text' name='petDetails' placeholder='Enter' value={form.petDetails} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Hobbies Interests</label>
                                <input type='text' name='hobbiesInterests' placeholder='Enter' value={form.hobbiesInterests} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-12 mt-5'>
                            <div className='formhead'>Relocation & Support Services</div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Settling Priorities</label>
                                <input type='text' name='settlingPriorities' placeholder='Enter' value={form.settlingPriorities} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Top Priorities</label>
                                <input type='text' name='topPriorities' placeholder='Enter' value={form.topPriorities} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Documentation Assistance</label>
                                <input type='text' name='documentationAssistance' placeholder='Enter' value={form.documentationAssistance} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Community Introductions</label>
                                <input type='text' name='communityIntroductions' placeholder='Enter' value={form.communityIntroductions} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>Settled Quickly Support</label>
                                <input type='text' name='settledQuicklySupport' placeholder='Enter' value={form.settledQuicklySupport} onChange={handleChange} />
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='form-group'>
                                <label>Additional Notes</label>
                                <textarea rows={4} name='additionalNotes' placeholder='Enter' value={form.additionalNotes} onChange={handleChange}></textarea>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>
        </>
    )
}

export default AddUser
